<template>  
<div> <!-- root element start -->
  <div class="card border-0">
    <div class="card-body border-bottom border-dark">
    	<div class="row d-flex align-items-center">
    		<div class="col-3">
          <span class="d-none d-lg-block">Quick Add:</span>
          <span class="d-xs-block d-lg-none">Add:</span>
    		</div>
        <div class="col-9 d-flex justify-content-around">
          
          <a href="#" @click="createOrg">
            <span class="d-none d-lg-block">Create Organization</span>
            <span class="d-xs-block d-lg-none"><i class="fa fa-building fa-2x" aria-hidden="true"></i></span>
          </a>
          <a href="#" @click="createContact">
            <span class="d-none d-lg-block">Create Contact</span>
            <span class="d-xs-block d-lg-none"><i class="fa fa-user fa-2x" aria-hidden="true"></i></span>
          </a>
          <a href="#" @click="createQuote">
            <span class="d-none d-lg-block">Create Quote</span>
            <span class="d-xs-block d-lg-none"><i class="fa fa-quote-right fa-2x" aria-hidden="true"></i></span>
          </a>
        </div>
    	</div>
    </div>

    <div class="card-body">
      <transition name="slide-fade" mode="out-in">
        <component :is="bottomView" :prop1="bvProp1" :prop2="bvProp2" :prop3="bvProp3" 
              @onSComplete="successComplete" @onUComplete="unsuccessComplete" @onSecComplete="onSecondary"></component>
      </transition>
    </div>
  </div>
</div> <!-- root element end -->
</template>

<style>

</style>

<script>
import { ScalingSquaresSpinner } from 'epic-spinners'
import {store} from '../../stores/user-dashboard-main-store.js'

import contactCreate from '../utilityComponents/contactComponents/contact-create.vue'
import orgCreate from '../utilityComponents/orgComponents/org-create.vue'
import quoteCreate from '../utilityComponents/quoteComponents/quote-create.vue'

export default {
  store,
  data: function () {
    return { 
      detailUrl: '/organization-detail/',
      bottomView: '',
      bvProp1: '',
      bvProp2: '',
      bvProp3: [],
    }
  },
  computed: {
    
  },
  watch: {
    
  },
  mounted() {

  },
  methods: {
    changeRightView(name, prop1, prop2, prop3) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2, prop3: prop3 }); },
    changeBottomView(name, prop1, prop2, prop3) { 
      var _this = this;
      _this.bottomView = name;
      _this.bvProp1 = prop1;
      _this.bvProp2 = prop2;
      _this.bvProp3 = prop3;
    },
    
    getLatestUserContacts() { this.$store.dispatch("getLatestUserContacts"); },
    getLatestUserOrgs() { this.$store.dispatch("getLatestUserOrgs"); },

    createContact() {
      var _this = this;
      _this.changeBottomView("create-contact", '', '', '')
    },

    createOrg() {
      var _this = this;
      _this.changeBottomView("create-org", '', '', '')
    },

    createQuote() {
      var _this = this;
      _this.changeBottomView("create-quote", '', '', '')
    },

    successComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'quote-save':
        _this.$emit('onSComplete', ['quote-save', value[1] ])
        _this.changeBottomView("", '', '', '')
        
        break;
        case 'contact-add':
        _this.$emit('onSComplete', ['contact-add', value[1] ])
        _this.changeBottomView("", '', '', '')
        
        break;
        case 'org-add':
        _this.$emit('onSComplete', ['org-add', value[1] ])
        _this.changeBottomView("", '', '', '')
        
        break;
        default:
      }
    },
    unsuccessComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'contact-add':
          _this.changeBottomView('', '', '', '');
        break;
        case 'org-add':
          _this.changeBottomView('', '', '', '');
        break;
        case 'quote-add':
          _this.changeBottomView('', '', '', '');
        break;
        default:
      }
    },
    onSecondary(value) {

    }

  },    
  components:{
    ScalingSquaresSpinner,
    'create-contact': contactCreate,
    'create-org': orgCreate,
    'create-quote': quoteCreate,
  },
  filters: {

  }
}
</script>

